import { InactiveEmployeesComponent } from './company-detail/inactive-employees/inactive-employees.component';
import { ActiveEmployeesComponent } from './company-detail/active-employees/active-employees.component';
import { AddCompanyComponent } from './add-company/add-company.component';
import { CompanyListComponent } from './company-list/company-list.component';
import { ErtComponent } from './company-detail/ert/ert.component';
import { AdminCoadminComponent } from './company-detail/admin-coadmin/admin-coadmin.component';
import { TabsComponent } from './../shared/tabs/tabs.component';
import { CompanyDetailComponent } from './company-detail/company-detail.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListComponent } from './shared/list/list.component';
import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from 'src/app/shared/shared.module'
import { CompanyViewComponent } from './company-view/company-view.component';

import { CreateMeetingRoomComponent } from './company-meeting-room/create-meeting-room/create-meeting-room.component';
import { ViewMeetingRoomComponent } from './company-meeting-room/view-meeting-room/view-meeting-room.component';
import { DetailsMeetingRoomComponent } from './company-meeting-room/details-meeting-room/details-meeting-room.component';
import { ViewMeetingRoomBookingComponent } from './company-meeting-room/view-meeting-room-booking/view-meeting-room-booking.component';

const routes: Routes = [
  { path: '', component: CompanyListComponent, },
  { path: 'details/:id', component: CompanyDetailComponent },
  { path: 'add-company', component: AddCompanyComponent },
  { path: 'edit-company/:id', component: AddCompanyComponent },
  { path: 'company-view/:id', component: CompanyViewComponent },

  { path: 'create-meeting-room/:id', component: CreateMeetingRoomComponent },
  { path: 'view-meeting-room/:id', component: ViewMeetingRoomComponent },
  { path: 'details-meeting-room', component: DetailsMeetingRoomComponent },
  { path: 'edit-meeting-room', component: CreateMeetingRoomComponent },
  { path: 'view-meeting-room-booking-company', component: ViewMeetingRoomBookingComponent },
]

@NgModule({
  declarations: [
    CompanyDetailComponent,
    TabsComponent,
    AdminCoadminComponent,
    ErtComponent, ListComponent,
    CompanyListComponent,
    AddCompanyComponent,
    ActiveEmployeesComponent,
    InactiveEmployeesComponent,
    CreateMeetingRoomComponent,
    ViewMeetingRoomComponent,
    DetailsMeetingRoomComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
  ],
  exports: [RouterModule],
})
export class CompanyModule { }
